export default __webpack_public_path__ + "static/media/flag-american-samoa.16d9fb86.svg";